module.exports = __webpack_public_path__ + "static/media/10-item-a.3598b43d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/10-item-a.jpg
// module id = 1194
// module chunks = 33